export const ANALYTICS_EVENTS = {
    ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
    LEASE_CREATED: 'lease_created',
    TENANT_INVITED: 'tenant_invited',
    TENANT_INVITE_ACCEPTED: 'tenant_invite_accepted',
    FIRST_PAYMENT_COMPLETED: 'first_payment_completed',
    PAYMENT_INITIATED: 'payment_initiated',
    PAYMENT_SUCCEEDED: 'payment_succeeded',
    PAYMENT_FAILED: 'payment_failed',
    FEATURE_USED: 'feature_used',
    DOCUMENT_SIGNED: 'document_signed',
    CHAT_MESSAGE_SENT: 'chat_message_sent',
    LANDING_CTA_CLICKED: 'landing_cta_clicked',
    ERROR_SHOWN: 'error_shown',
};
//# sourceMappingURL=events.js.map